<template>
  <ComplexCard
    :id="partnerKey"
    class="min-w-[212px]"
    variant="small"
    :header-image-url="headerImageUrl"
    :title="title"
    :details-url="detailsUrl"
    :first-line-text="firstLineText"
    :second-line-text="secondLineText"
    open-in-new-window
    tall-header
    @cta-clicked="ctaClicked"
  />
</template>

<script lang="ts">
import ComplexCard from '@/components/complex_card/ComplexCard.vue';

export default {
  name: 'BHPartnerCard',
  components: {
    ComplexCard,
  },
  props: ['observer', 'headerImageUrl', 'title', 'detailsUrl', 'firstLineText', 'secondLineText', 'partnerKey'],
  mounted() {
    this.observer.observe(this.$el);
  },
  methods: {
    ctaClicked() {
      this.$emit('ctaClicked', this.partnerKey);
    },
  },
};
</script>
